import logo from './Alpha logo.png';
import './App.css';

function App() {
  return (
    <div className="App">
     <div className="container mt-5 mx-auto">
      <div className="row">
        <div className="col">
          {/* <!--card1--> */}
          <div className="card-main-div border border-5 rounded">
            <div>
              <div className="card1-pic-main border border-start-0 border-end-0 border-top-0 border-secondary border-opacity-30 border-5">
                <p className="profile-name h1 pt-5 text-center">Alpha Tech</p>
                <p className="text-white text-center">Webpro Connect</p>
              </div>
            </div>
            <div className="profile-pic-div mb-2 text-center">
              <img
                className="profile-pic border border-5"
                src={logo}
                alt="Profile"
              />
            </div>
            {/* <!--About me--> */}
            <div className="">
              <p className="h4 ms-3"> About Us</p>
              <p className="ms-3 pe-3 lh-sm about-details">
              Our skilled tech team, including seasoned website developers, innovative graphic designers, and skilled video editors, collectively brings professionalism and excellence through their expertise.
              </p>
              <br></br>
            </div>
            {/* <!--skills--> */}
            <div className="">
              <p className="h4 ms-3"> Services</p>
              <p className="ms-3 pe-3 lh-sm">Website Development, Social Media Management and Designing</p>
            </div>
            {/* <!--Contacts--> */}
            <div className="contact-div pt-3 pb-1  border border-start-0 border-end-0 border-bottom-0 border-secondary border-opacity-30">
              <div className="">
                <p className="h4 contact-heading"> Contacts</p><br></br>
                {/* <!--Mobile no--> */}
                <p className="ms-5 text-white pe-3 lh-sm about-details">
                  <i className="bi bi-telephone-fill me-2"></i>+91 8434665254
                </p>

                {/* <!--email--> */}
                <p className="ms-5 text-white pe-3 lh-sm about-details">
                  <i className="bi bi-envelope-fill me-2"></i>salman.srk111@gmail.com
                </p>

                {/* <!--Location--> */}
                <p className="ms-5 text-white pe-3 lh-sm about-details">
                  <i className="bi bi-geo-alt-fill me-2"></i> Bhugaon, Mulshi, Pune - 412115
                </p>

              </div>
              <hr className="text-white" />
              <div className='px-3 py-2 d-flex justify-content-around'>
              <a href="https://salman-2022.github.io/src/alpha/Alphatech%20Pune/index.html">
                <button type="button" className="btn btn-secondary bg-white text-black" ><b>Tell Me More</b></button>
              </a>
              <a href="https://wa.me/+918434665254">
                <button type="button" className="btn btn-secondary bg-black text-white" ><b>Chat With Us</b></button>
              </a>
              </div>
            </div>
          </div>
          {/* <!--card1 end--> */}
        </div>
      </div>
    </div>
    </div>
  );
}

export default App;
